import _extends from "@babel/runtime/helpers/extends";
import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
import { css } from '@emotion/react';
import FlexibleCard from '../../../FlexibleCard';
import { CustomBlock, InternalFooterBlock, PreviewBlock, TitleBlock } from '../../../FlexibleCard/components/blocks';
import { FlexibleCardUiOptions, FooterBlockOptionsOld, PreviewBlockOptions, titleBlockOptionsOld } from '../utils';
var customBlockStyles = css({
  alignItems: 'flex-start'
});
var UnresolvedViewOld = function UnresolvedViewOld(_ref) {
  var actions = _ref.actions,
    cardState = _ref.cardState,
    children = _ref.children,
    onAuthorize = _ref.onAuthorize,
    onClick = _ref.onClick,
    onError = _ref.onError,
    _ref$showPreview = _ref.showPreview,
    showPreview = _ref$showPreview === void 0 ? false : _ref$showPreview,
    testId = _ref.testId,
    title = _ref.title,
    url = _ref.url;
  return /*#__PURE__*/React.createElement(FlexibleCard, {
    appearance: "block",
    cardState: cardState,
    onAuthorize: onAuthorize,
    onClick: onClick,
    onError: onError,
    origin: "smartLinkCard",
    testId: testId,
    ui: FlexibleCardUiOptions,
    url: url
  }, /*#__PURE__*/React.createElement(TitleBlock, _extends({}, titleBlockOptionsOld, {
    hideIcon: !!title,
    text: title
  })), /*#__PURE__*/React.createElement(CustomBlock, {
    overrideCss: customBlockStyles
  }, children), showPreview && /*#__PURE__*/React.createElement(PreviewBlock, PreviewBlockOptions), /*#__PURE__*/React.createElement(InternalFooterBlock, _extends({}, FooterBlockOptionsOld, {
    actions: actions,
    testId: "smart-block-card-footer"
  })));
};
export default UnresolvedViewOld;